// @script
import defaultValues from './default-values.json';
import driveType from './drive-type.json';
import languages from './languages.json';

/**
 * @param {Object} text - The current object of texts.
 * @return {{
 *  description: string,
 *  id: string
 * }[]}
 */
export const getMasterData = (text) => {
    const masterData = {
        defaultValues,
        driveType,
        languages
    };

    Object.keys(masterData).forEach((key) => {
        masterData[key] = Array.isArray(masterData[key])
            ? masterData[key].map((masterItem) => ({
                ...masterItem,
                description:
                    (
                        Boolean(text.masterData[key])
                        && text.masterData[key][masterItem.id]
                    )
                    || masterItem.description
            })) : masterData[key];
    });

    return masterData;
};
